// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2GOI5","selected":"Chip_selected__27gYj"};